import { Button, Card, Col, Row } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Title from 'antd/lib/typography/Title';
import ExampleBtn from './ExampleBtn';
import { useHistory } from 'react-router-dom';

export const ExplanationRow = ({ handleBuyReport }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Row gutter={[30]}>
      <Col md={24} lg={12} style={{ display: 'flex' }}>
        <Card className={`card-simple card-simple-padding-none space-vertical-sm has-shadow`} style={{ width: '100%' }}>
          <Row>
            <Col span={24}>
              <Title className="fw-600" level={4} style={{ fontSize: 20 }}>
                {t('companyResult.report.sample.title')}
              </Title>
              <ul style={{ paddingLeft: 20 }}>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.1" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.2" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.3" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.4" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.5" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.6" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.7" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.8" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.9" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.sample.paragraph.10" components={{ bold: <strong /> }} />{' '}
                </li>
              </ul>
              <Row gutter={[16, 0]}>
                <Col>
                  <span>{t('companyResult.buyReport.reportTable.ps')}</span>
                </Col>
                <Col>
                  <span>{t('companyResult.buyReport.reportTable.pss')}</span>
                </Col>
              </Row>
            </Col>
            <Col span={24} style={{ alignSelf: 'end' }} className="space-top-xsm">
              <ExampleBtn />
            </Col>
          </Row>
        </Card>
      </Col>
      <Col md={24} lg={12} style={{ display: 'flex' }}>
        <Card className={`card-simple card-simple-padding-none space-vertical-sm has-shadow`} style={{ width: '100%' }}>
          <Row style={{ height: '100%' }}>
            <Col span={24}>
              <Title className="fw-600" level={4}>
                {t('companyResult.report.explanationBuy.title')}
              </Title>
              <ul style={{ paddingLeft: 20 }}>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.1" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.2" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.3" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.4" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.5" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.6" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.7" components={{ bold: <strong /> }} />{' '}
                </li>
                <li>
                  <Trans i18nKey="companyResult.report.explanationBuy.paragraph.8" components={{ bold: <strong /> }} />{' '}
                </li>
              </ul>
            </Col>
            <Col span={24} style={{ alignSelf: 'end' }}>
              <Row gutter={[30, 16]} style={{ justifyContent: 'start' }}>
                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    className="btn-success-bordered"
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => history.push(`/search/company/consultation`)}
                  >
                    {t('companyResult.button.register')}
                  </Button>
                </Col>
                <Col>
                  <Button className="btn-success" onClick={handleBuyReport}>
                    {t('companyResult.button.buyReport')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
